import type {CrudSorting} from '@refinedev/core';

export const generateSort = (sorters?: CrudSorting) => {
  if (sorters && sorters.length > 0) {
    const sortParams = sorters.map((item) => {
      return item.order === 'desc' ? `${item.field},desc` : item.field;
    });

    return {
      order: sortParams,
    };
  }

  return;
};
